import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import NetSparkerConfigListing from './NetSparkerConfigListing'
import NetSparkerCredentialsForm from './NetSparkerCredentialsForm'

export default function NetSparkerPullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={NetSparkerCredentialsForm}
            PullConfigListingView={NetSparkerConfigListing}
        />
    )
}